import { render } from "./InvestasiDataStatus.vue?vue&type=template&id=6cc73b0f"
import script from "./InvestasiDataStatus.vue?vue&type=script&lang=js"
export * from "./InvestasiDataStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__